module.exports = __webpack_public_path__ + "img/analysis_putaway_black.4ae7dd2d.svg";